module.exports = __webpack_public_path__ + "img/1.b54f8517.png";